import { connect } from 'react-redux'
import HeaderCustomerSelect from 'components/HeaderCustomerSelect'

const mapStateToProps = (state: any) => {
  return {
    customerName: state.customerName,
  }
}

export default connect(mapStateToProps)(HeaderCustomerSelect)
